import paths from "@icarius-router/paths";
import { numberFilterParams, createNumberFormatter } from "@icarius-table/number";
import { getLocalizedString } from "@icarius-localization/strings";

export default () => [
    {
        pages: [paths.distributionCost],
        config: {
            headerName: getLocalizedString("employeesProcessCentroBeneficio"),
            field: "Centro de costo",
            isObligatory: false,
            isSelect: true,
        }
    },
    {
        pages: [paths.distributionCost],
        config: {
            headerName: getLocalizedString("employeesProcessProyecto"),
            field: "Proyecto",
            isObligatory: false,
            isSelect: true,
        }
    },
    {
        pages: [paths.distributionCost],
        config: {
            headerName: getLocalizedString("employeesProcessDimension2"),
            field: "Dimensión 2",
            isObligatory: false,
            isSelect: true,
        }
    },
    {
        pages: [paths.distributionCost],
        config: {
            headerName: getLocalizedString("employeesProcessDimension3"),
            field: "Dimensión 3",
            isObligatory: false,
            isSelect: true,
        }
    },
    {
        pages: [paths.distributionCost],
        config: {
            headerName: getLocalizedString("employeesProcessDimension4"),
            field: "Dimensión 4",
            isObligatory: false,
            isSelect: true,
        }
    },
    {
        pages: [paths.distributionCost],
        config: {
            headerName: getLocalizedString("employeesProcessDimension5"),
            field: "Dimensión 5",
            isObligatory: false,
            isSelect: true,
        }
    },
    {
        pages: [paths.distributionCost],
        config: {
            headerName: getLocalizedString("employeesProcessPorcentaje"),
            field: "Porcentaje",
            filterParams: numberFilterParams(),
            valueFormatter: createNumberFormatter(0, 3),
            isNumeric: false,
            isObligatory: true,
            maxLength: 9,
            minLength: 1,
            validationUnrequired: true,
            isQuantityEntryPerConceptSet: true
        }
    },
]